var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCohorts({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M13.6665 6.79331H11.7398C10.1598 6.79331 8.87317 5.50665 8.87317 3.92665V1.99998C8.87317 1.63331 8.57317 1.33331 8.2065 1.33331H5.37984C3.3265 1.33331 1.6665 2.66665 1.6665 5.04665V10.9533C1.6665 13.3333 3.3265 14.6666 5.37984 14.6666H10.6198C12.6732 14.6666 14.3332 13.3333 14.3332 10.9533V7.45998C14.3332 7.09331 14.0332 6.79331 13.6665 6.79331Z",
    fill: "#075FCC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5333 1.47335C10.26 1.20002 9.78662 1.38668 9.78662 1.76668V4.09335C9.78662 5.06668 10.6133 5.87335 11.62 5.87335C12.2533 5.88002 13.1333 5.88002 13.8866 5.88002C14.2666 5.88002 14.4666 5.43335 14.2 5.16668C13.24 4.20002 11.52 2.46002 10.5333 1.47335Z",
    fill: "#075FCC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 9.16669H5C4.72667 9.16669 4.5 8.94002 4.5 8.66669C4.5 8.39335 4.72667 8.16669 5 8.16669H9C9.27333 8.16669 9.5 8.39335 9.5 8.66669C9.5 8.94002 9.27333 9.16669 9 9.16669Z",
    fill: "#075FCC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.66667 11.8333H5C4.72667 11.8333 4.5 11.6066 4.5 11.3333C4.5 11.06 4.72667 10.8333 5 10.8333H7.66667C7.94 10.8333 8.16667 11.06 8.16667 11.3333C8.16667 11.6066 7.94 11.8333 7.66667 11.8333Z",
    fill: "#075FCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCohorts);
export default __webpack_public_path__ + "static/media/cohorts.f065a287969310bd5a885d0bfe43ebeb.svg";
export { ForwardRef as ReactComponent };